// The audio-ledger rollout cohort, stamped onto audio-recording logs only: a
// global context property would tag every record the app emits. RUM keeps its
// global stamp app-side, where Error Tracking needs the cohort session-wide.
//
// Dependency-free on purpose: `pipelineMode` writes it, `./logger` reads it, and
// `pipelineMode` already imports `./logger`.
let cohort: string | undefined;

/** Called once per page load by the pipeline-mode coordinator, at the pin. */
export const setLogCohort = (pipelineMode: string): void => {
  cohort = pipelineMode;
};

/** `undefined` before the writer is pinned — those records go out untagged. */
export const getLogCohort = (): string | undefined => cohort;

/** Cleared with the pinned mode by `@heidi/capture/testing`'s reset. */
export const resetLogCohort = (): void => {
  cohort = undefined;
};
